import { render, staticRenderFns } from "./OrganismMainLocations.vue?vue&type=template&id=4b7405f0&"
import script from "./OrganismMainLocations.vue?vue&type=script&lang=js&"
export * from "./OrganismMainLocations.vue?vue&type=script&lang=js&"
import style0 from "./OrganismMainLocations.vue?vue&type=style&index=0&id=4b7405f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports